import {ImportingDataTypes} from "../../types";
import {createBooleanField, createInvalidPartSection, PreventionInvalidityCode} from "./shared";

export const preventativeInteraction = {
    datasourceId: ImportingDataTypes.partNotes,
    sections: [
        createInvalidPartSection(),
        {
            sectionKey: 'invalidPrivateNote',
            sectionTitle: 'Invalid Note Privacy',
            invalidityCode: PreventionInvalidityCode.INVALID_BOOLEAN,
            fields: [createBooleanField('isPrivate', 'Is Private'),]
        },
        {
            sectionKey: 'missingNotesFields',
            sectionTitle: 'Missing Required Note Fields',
            invalidityCode: PreventionInvalidityCode.MISSING_REQUIRED_FIELDS,
            fields: [
                {
                    key: 'partNumber',
                    label: 'Part Number',
                    type: 'text',
                    extractValue: (o) => typeof o === 'string' ? o : o?.partNo ?? null, // partNo is explicitly used since autocomplete provides partNo field
                    modifyRow: (row, val) => ({...row, partNumber: val})
                },
                {
                    key: 'title',
                    label: 'Title',
                    type: 'input',
                    modifyRow: (row, val) => ({...row, title: val})
                },
                {
                    key: 'message',
                    label: 'Message',
                    type: 'input',
                    modifyRow: (row, val) => ({...row, message: val})
                }
            ]
        }
    ],
};
